// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * WL.Api
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime'
import type { ActivityDataRepresentation } from './ActivityDataRepresentation'
import {
  ActivityDataRepresentationFromJSON,
  ActivityDataRepresentationFromJSONTyped,
  ActivityDataRepresentationToJSON,
} from './ActivityDataRepresentation'

/**
 *
 * @export
 * @interface ActivityDataRepresentationBaseApiListResult
 */
export interface ActivityDataRepresentationBaseApiListResult {
  /**
   *
   * @type {Array<ActivityDataRepresentation>}
   * @memberof ActivityDataRepresentationBaseApiListResult
   */
  data: Array<ActivityDataRepresentation>
  /**
   *
   * @type {number}
   * @memberof ActivityDataRepresentationBaseApiListResult
   */
  total: number
}

/**
 * Check if a given object implements the ActivityDataRepresentationBaseApiListResult interface.
 */
export function instanceOfActivityDataRepresentationBaseApiListResult(
  value: object,
): boolean {
  let isInstance = true
  isInstance = isInstance && 'data' in value
  isInstance = isInstance && 'total' in value

  return isInstance
}

export function ActivityDataRepresentationBaseApiListResultFromJSON(
  json: any,
): ActivityDataRepresentationBaseApiListResult {
  return ActivityDataRepresentationBaseApiListResultFromJSONTyped(json, false)
}

export function ActivityDataRepresentationBaseApiListResultFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): ActivityDataRepresentationBaseApiListResult {
  if (json === undefined || json === null) {
    return json
  }
  return {
    data: (json['data'] as Array<any>).map(ActivityDataRepresentationFromJSON),
    total: json['total'],
  }
}

export function ActivityDataRepresentationBaseApiListResultToJSON(
  value?: ActivityDataRepresentationBaseApiListResult | null,
): any {
  if (value === undefined) {
    return undefined
  }
  if (value === null) {
    return null
  }
  return {
    data: (value.data as Array<any>).map(ActivityDataRepresentationToJSON),
    total: value.total,
  }
}
